import styled from "styled-components";
import { device } from "../../themes/Breakpoints";

export const DraftConfigWrap = styled.section`
  margin-top: 25px;
  margin-bottom: 200px;
  .line {
    margin-top: 0px;
  }
  @media only screen and (max-width:1024px) {
    margin-bottom: 40px;
  }
`;
export const DraftContainer = styled.div`
  
`;
export const DraftHeading = styled.div`
  margin-bottom: 23px;
  .title {
    color: #000000;
    font-size: 36px;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 400;
    margin-bottom: 0;
  }
  p {
    color: #3E464F;
    font-size: 20px;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-weight: 400;
    }
  @media only screen and (max-width: 600px) {
    font-size: 26px;
  }
`;
export const SelectTeams = styled.div`
  display: flex;
  border-radius: 10px;
  @media ${device.tablet} {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media ${device.mobileL} {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media ${device.mobileM} {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media ${device.mobileS} {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
export const DraftTeams = styled.div`
  max-width: 956px;
  width: 100%;
  background-color: white;
  height: auto;
  padding: 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  p {
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    color: #989ea4;
  }
  .select-all {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    color: #3e464f;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 400;
    font-size: 16px;
    input {
      margin-right: 12px;
    }
  }
  .teams-title {
    font-size: 20px;
    color: #3e464f;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 600;
    margin-bottom: 0;
  }
  .count-title{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 57px;
    color: #022142;
    margin-top: -25px;
  }
  .select-all {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    input {
      margin-right: 12px;
    }
  }
  @media only screen and (min-width: 900px) and (max-width:1000px) {
    .count-title {
      justify-content: flex-start;
      margin-top:0;
      font-size: 26px;
      line-height: 34px;
    }
  }
  @media ${device.tablet} {
    margin-bottom: 30px;
    .select-teams {
      flex-wrap: wrap;
      justify-content: center;
    }
    .count-title {
      justify-content: flex-start;
      margin-top:0;
      font-size: 26px;
      line-height: 34px;
    }
  }
  @media ${device.mobileL} {
    margin-bottom: 30px;
    .select-teams {
      flex-wrap: wrap;
      justify-content: center;
    }
    .count-title {
      justify-content: flex-start;
      margin-top:0;
      font-size: 24px;
      line-height: 32px;
    }
  }
  @media ${device.mobileM} {
    margin-bottom: 30px;
    .select-teams {
      flex-wrap: wrap;
      justify-content: center;
    }
    .count-title {
      justify-content: flex-start;
      margin-top:0;
      font-size: 24px;
      line-height: 32px;
    }
  }
  @media ${device.mobileS} {
    margin-bottom: 30px;
    .select-teams {
      flex-wrap: wrap;
      justify-content: center;
    }
    .count-title {
      justify-content: flex-start;
      margin-top:0;
      font-size: 24px;
      line-height: 32px;
    }
  }
`;
export const TeamsSettings = styled.div`
  max-width: 472px;
  width: 100%;
  background-color: white;
  height: auto;
  border-left: 1px solid #ebedef;
  padding: 24px 32px 24px 24px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  @media ${device.tablet} {
    max-width: 100%;
    margin-left: 0;
  }
`;
